import React from "react";

const Loading = () => {
  return (
    <div className="flex items-center justify-center my-20">
      <div className="w-16 h-16 border-b-2 border-accent rounded-full animate-spin bg-clip-text"></div>
    </div>
  );
};

export default Loading;
